import theme from '../themes/default';
import orderPlsImage from '../../images/waiterpls.png';
import creditCardImage from '../../images/credit_card.js'
import weChatPayImage from '../../images/wechat_pay.js'

export default {
	wrap: {
		position: 'fixed',
		bottom: '0',
		width: '100%',
		// 'background': '#fff',
		// 'box-shadow': '0 -11px 21px 0 rgba(0, 0, 0, 0.26)',
		'z-index': '3'
	},
	tncWrap: {
		'z-index': '1',
		position: 'fixed',
		bottom: '65px',
		width: '100vw'
	},
	tnc: {
		width: '300px',
		'max-width': '80vw',
		color: 'rgba(0,0,0,0.5)',
		margin: '0 auto',
		'text-align': 'center'
	},
	tncLink: {
		color: '#D5AD40',
		opacity: '0.9'
	},
	'checkout-footer': {
		height: '60px',
		// 'box-shadow': '0 -11px 21px 0 rgba(0, 0, 0, 0.26)',
		'border-top': '1px solid #e5e5e5',
		background: '#fff'
	},
	'common-footer-order-wrap': {
		background: '#fff',
		'box-shadow': '0 -11px 21px 0 rgba(0, 0, 0, 0.26)',
		height: '60px'
	},
	'common-footer-order-setItem-wrap': {
		height: '75px',
		'text-align': 'left',
		background: '#fff',
		display: 'flex',
		'align-items': 'center'
	},
	'common-footer-skip-wrap': {
		'text-align': 'right',
		background: '#fff',
		display: 'flex',
		width: '100%',
		'align-items': 'center',
	  },
	'common-footer-logo': {
		width: '35%',
		height: '60px',
		float: 'left',
		background: `url(${orderPlsImage})`,
		'background-position': 'center',
		'background-repeat': 'no-repeat',
		'background-size': '70%',
		visibility: 'block'
	},
	'common-footer-logo-home': {
		display: 'flex',
		'justify-content': 'center',
		'align-items': 'flex-start'
	},
	'common-footer-logo-hidden': {
		width: '35%',
		height: '35px',
		'padding-top': '20px',
		'vertical-align': 'middle',
		float: 'left',
		'text-align': 'center',
		'background-position': 'center',
		'background-repeat': 'no-repeat',
		'background-size': '70%',
		visibility: 'block'
	},
	'choose-table-text': {
		padding: '0 16px'
	},
	'common-footer-selection': {
		width: '35%',
		height: '60px',
		float: 'left',
		'& label': {
			display: 'flex',
			'align-items': 'center',
			'justify-content': 'flex-start',
			// width: '50%',
			// float: 'left',
			height: '100%',
			'font-size': '22px'
		},
		'& select': {
			border: 'none',
			'background-image': 'none',
			'background-color': 'transparent',
			'-webkit-box-shadow': 'none',
			'-moz-box-shadow': 'none',
			'box-shadow': 'none',
			width: '50%',
			height: '100%',
			'font-size': '22px',
			float: 'right'
		}
	},
	'common-footer-confirm-order': {
		width: '65%',
		height: '60px',
		float: 'left'
	},
	'common-total-order': {
		width: '40%',
		float: 'left',
		'padding-top': '15px'
	},
	'common-total-order-preorder': {
		width: '100%',
		'padding-top': '12px',
		'& > div': {
			'font-size': '14px'
		}
	},
	'common-total-order-prefix-text': {
		color: '#A59996',
		'font-size': '12px',
		'padding-left': '15px',
		'border-left': '1px dotted #A59996',
		'& span': {
			'margin-left': '3px'
		}
	},
	'common-total-order-text': {
		'padding-left': '15px',
		'border-left': '1px dotted #A59996'
	},
	'common-checkout-order': {
		width: '60%',
		float: 'left',
		height: '100%',
		background: '#D5AD40',
		borderRadius: '30px 0px 0px 30px',
		color: '#fff',
		'& .badge': {
			position: 'absolute',
			top: '5px',
			right: '3px',
			background: 'rgb(197, 69, 69)',
			'min-width': '12px',
			height: '20px',
			'line-height': '21px',
			padding: '0 5px',
			borderRadius: '10px',
			color: '#fff',
			'text-align': 'center'
		}
	},
	'common-checkout-order-text': {
		'font-size': '16px',
		'text-align': 'center',
		display: 'flex',
		'align-items': 'center',
		height: '100%',
		'& span': {
			margin: '0 auto'
		}
	},
	'common-checkout-order-text-small': {
		'font-size': '15px'
	},
	'common-total-order-number': {
		'margin-right': '5px'
	},

	'checkout-footer-confirm-order': {
		width: '100%',
		height: '60px'
	},
	'checkout-total-order': {
		width: 'calc(100%/3)',
		// 'padding-top': '10px',
		'text-align': 'right',
		display: 'inline-block',
		height: '100%',
		'border-left': '1px dotted #A59996'
	},
	'checkout-total-order-full': {
		width: '100%',
		float: 'left',
		'padding-top': '10px',
		'text-align': 'right'
	},
	'checkout-total-order-prefix-text': {
		color: '#A59996',
		'font-size': '12px',
		'padding-right': '10px',
		// 'border-left': '1px dotted #A59996',
		'& span': {
			'&:first-child': {
				'margin-right': '2px'
			},
			'&:last-child': {
				'margin-left': '2px'
			}
		}
	},
	'checkout-total-order-text': {
		'padding-right': '10px',
		// 'border-left': '1px dotted #A59996',
		'padding-top': '4px',
		'font-weight': 'bold',
		'font-size': '16px',
		'& div': {
			display: 'inline-block'
		}
	},
	'checkout-checkout-order': {
		width: 'calc(100%/3)',
		height: '100%',
		background: '#D5AD40',
		borderRadius: '30px 0px 0px 30px',
		color: '#fff',
		display: 'inline-block'
	},
	'common-checkout-order-disable': {
		background: '#ccc',
		'pointer-events': 'none'
	},
	'common-checkout-order-preorder': {
		display: 'none'
	},
	'checkout-checkout-order-text': {
		'padding-left': '15px',
		'font-size': '16px',
		'text-align': 'center',
		'letter-spacing': '2px',
		display: 'flex',
		'align-items': 'center',
		height: '100%',
		'& span': {
			margin: '0 auto'
		}
	},
	'checkout-total-order-price-prefix': {
		'font-size': '13px',
		'vertical-align': 'middle',
		height: '22px',
		'margin-right': '1px'
	},
	'common-footer-package-left': {
		flex: '1',
		height: '70px',
		padding: '12px 15px 0 15px'
	},
	'common-footer-package-right': {
		background: '#4a8ca1',
		color: '#fff',
		height: '55px',
		display: 'flex',
		'align-items': 'center',
		padding: '0 15px',
		'margin-right': '15px',
		flex: '0.6',
		borderRadius: '30px'
	},
	'common-footer-skip-text': {
		color: '#2e7186',
		width: '100%',
		'padding-right': '50px',
		'padding-top': '20px',
		'padding-bottom': '20px',
	  },
	'common-footer-package-choosing-text': {
		margin: '2px 0px',
		color: '#a59996',
		'font-size': '12px'
	},
	'common-footer-package-dish': {
		'margin-left': '10px'
	},
	'common-footer-package-badge-wrap': {
		'margin-top': '4px',
		'margin-left': '-2px',
		'& sup': {
			'background-color': '#c54545 !important',
			padding: '2px 15px'
		}
	},
	'common-footer-package-button': {
		margin: '0 auto'
	},
	'common-footer-package-button-icon': {
		width: '20px',
		margin: '-1px 10px 0 auto',
		float: 'left',
		'& img': {
			width: '100%'
		}
	},
	'common-footer-package-button-text': {
		float: 'left'
	},
	'change-table-button': {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		background: '#4A8CA1',
		color: '#fff',
		fontSize: 16,
		height: '100%'
	},
	'change-table-button-invalid': {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		background: '#D8D8D8',
		color: '#fff',
		fontSize: 16,
		height: '100%'
	},
	'payment-option': {
		position: 'relative',
		overflow: 'hidden',
		background: '#fff',
		'box-shadow': '0 4px 17px 0 rgba(160, 156, 156, 0.36)',
		'margin-bottom': '20px',
		'border-top-left-radius': '15px',
		'border-top-right-radius': '15px',
		'border-bottom-left-radius': '15px',
		'border-bottom-right-radius': '15px',
		'& > div:nth-child(2)': {
			'border-bottom': 'none !important',
			'padding-bottom': '0 !important'
		},
		width: '100%',
		height: '50px',
		'margin-top': '15px',
		padding: '20px 0',

		'& iframe': {
			float: 'none !important'
		},
		'& > div': {
			padding: '0 20px'
		}
  },
  'payment-option-wechatpay': {
    height: '50px',
    background: weChatPayImage,
    'background-size': 'contain',
    'background-repeat': 'no-repeat',
  },
	'payment-option-credit-card': {
		height: '50px',
		background:
			creditCardImage +
			', url(https://res.cloudinary.com/dimorder/image/upload/v1583760602/credit_card_1.3de75fe2_ykg93k.jpg)',
		'background-size': 'contain',
		'background-repeat': 'no-repeat'
	}
};



// WEBPACK FOOTER //
// ./src/assets/styles/components/Footer.js